import {
  CANCEL_LARGE_FILES,
  DASHBOARDCOMMITCHUNKS,
  DASHBOARDSTAGECHUNKS,
  DELETEFILES,
  DM_FILE_DOWNLOAD_API,
  FILEEXISTS,
  GETALLFILES,
  GETFILESWITHSEARCH,
  GETORGDETAILS,
  GETSTORAGECONSUMPTION,
  GETUSERPERMISSIONRESOURCES,
} from "../../../../../common/apiEndPoint/apiEndPoint";
import { config } from "../../../../../common/authentication/config";
import { store } from "../../../../../store";
import {
  apiClient,
  getControllerSignal,
} from "../../common/interceptor/base.services";
import { calculatePercentage } from "../store/file-management.action";

export const siteIdStatic = config?.SITE_ID;
export const ACADEMY_TENANT_ID = config?.ACADEMY_TENANT_ID;

export const getUserPermission = () => {
  return apiClient.get(`${GETUSERPERMISSIONRESOURCES}`);
};

export const getOrgDetails = () => {
  return apiClient.get(`${GETORGDETAILS}`);
};

export const getStorageConsumption = (ContainerId: string) => {
  return apiClient.get(`${GETSTORAGECONSUMPTION}?container=${ContainerId}`);
};

export const getDeviceInstanceApi = (uri: string) => {
  return apiClient.get(`${GETALLFILES}?${uri}`);
};

export const uploadFile = (data: any) => {
  return apiClient.post(`${DASHBOARDSTAGECHUNKS}`, data, {
    headers: {
      contentType: "multipart/form-data",
    },
  });
};

export const committedChunks = (data: any) => {
  return apiClient.post(`${DASHBOARDCOMMITCHUNKS}`, data, {
    signal: getControllerSignal(),
  });
};

export const deleteFiles = (data: any) => {
  return apiClient.delete(`${DELETEFILES}`, {
    data,
  });
};

export const downloadFiles = (data: any) => {
  return apiClient.post(`${DM_FILE_DOWNLOAD_API}`, data);
};

export const checkFileNameExist = (url: any) => {
  return apiClient.get(`${FILEEXISTS}?${url}`);
};

export const searchFiles = (value: any) => {
  return apiClient.get(`${GETFILESWITHSEARCH}?searchFileName=${value}`);
};

export const cancelLargefiles = () => {
  return apiClient.get(`${CANCEL_LARGE_FILES}`);
};
